import Modal, {ModalProps} from 'react-bootstrap/Modal';
import React, {useEffect, useState} from "react";
import axios from "axios";

import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";
import {useStockStorage} from "../../hooks/useStockStorage";

import {useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

import { Form, FloatingLabel, Button, Row, Col, Figure, FormLabel, Spinner } from 'react-bootstrap';
import {useSanctum} from "react-sanctum";

import {
    defaultNONE,
    defaultEMPTY,
    defaultMomentDateFormat
} from "../../config/global";

import {useToolkit} from "../../hooks/useToolkit";
import moment from 'moment';

import JSONRegions from '../../../../json/databasecomuni/italy_regions.json'
import JSONProvincies from '../../../../json/databasecomuni/italy_provincies.json'

const SubscriptionFlow = ({openStocks, goToLounge, ...props}: ModalProps)  => {
    
    const [jsonRegion, setJSONRegion] = useState(JSONRegions.italy_regions);
    const [jsonProvince, setJSONProvince] = useState(JSONProvincies.italy_provincies);

    const [regione, setRegione] = useState(defaultEMPTY);
    const [provincia, setProvincia] = useState(defaultEMPTY);
    const { decodeRegione,
        decodeProvincia,
        decodeComune } = useToolkit();
    const { t } = useTranslation();
    const location = useLocation();
    
    const { user } = useSanctum();

    const{getAppUniqueToken, setAppUniqueToken, removeAppUniqueToken} = useAppUniqueToken();
    const{setSessionStock, setNewSessionStock, removeNewSessionStock, setSessionStockRegion, setSessionStockProvince, setSessionStockPromoter} = useStockStorage();
    const { removeCurrentQuote } = useToolkit();
    const [uaToken, setUaToken] = useState(getAppUniqueToken);
    const navigate = useNavigate();

    const [selectedStock, setSelectedStock] = useState();
    const [stockName, setStockName] = useState(defaultEMPTY);
    const [stockToken, setStockToken] = useState(defaultEMPTY);
    const [newStock, setNewStock] = useState(false);
    const [newStockAndClose, setNewStockAndClose] = useState(false);
    const [continueStock, setContinueStock] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isLogout, setIsLogout] = useState(false);
    const [stockPromoter, setStockPromoter] = useState(defaultEMPTY);

    let payload = {
        
        stockPromoter: defaultEMPTY,
        stockName: defaultEMPTY,
        stockToken: defaultEMPTY,
        regione: defaultEMPTY,
        provincia: defaultEMPTY

    }
    const [errors, setErrors] = useState(payload)
    const [formErrors, setFormErrors] = useState(payload);
    const setField = (field: any, value: any) => {
        
        if(field === 'regione') { setErrors({...errors, regione: defaultEMPTY}); setRegione(value); }
        else if(field === 'provincia') { setErrors({...errors, provincia: defaultEMPTY}); setProvincia(value); }
        else if(field === 'stockPromoter') { setErrors({...errors, stockPromoter: defaultEMPTY}); setStockPromoter(value); }
        
    }
    const findFormErrors = (blurField = defaultEMPTY) => {
        setFormErrors(payload);

        if (!regione || regione === '' || regione === defaultEMPTY || regione === defaultNONE) { formErrors.regione = t('messages.mandatoryField') }
        //if (!provincia || provincia === '' || provincia === defaultEMPTY || provincia === defaultNONE) { formErrors.provincia = t('messages.mandatoryField') }
        
        if (!stockPromoter || stockPromoter === '' || stockPromoter === defaultEMPTY || stockPromoter === defaultNONE) { formErrors.stockPromoter = t('messages.mandatoryField') }
        

        return formErrors
    }
    const formReset = () => {
        setErrors({...errors, regione: defaultEMPTY}); setRegione(user.user.system_region ? user.user.system_region : defaultEMPTY);
        setErrors({...errors, provincia: defaultEMPTY}); setProvincia(defaultEMPTY);
        setErrors({...errors, stockPromoter: defaultEMPTY}); setStockPromoter(defaultEMPTY);
    }
    const handleOnChangeRegion = (e: any) => {
        setField('regione', e.target.value);
        setField('provincia', defaultEMPTY);
    }
    const handleOnChangeProvince = (e: any) => {
        setField('provincia', e.target.value);
    }
    useEffect(() => {
        if(regione && regione !== defaultNONE && regione !== defaultEMPTY)
            setJSONProvince(JSONProvincies.italy_provincies.filter(x => x.id_regione === regione));
        else
            setJSONProvince(JSONProvincies.italy_provincies);
    }, [regione])
    

    useEffect(() => {
        if(user) {

            let _date = moment().format("DDMMYYYYhhmmss");
            let _user = (user.user.name + user.user.surname).toUpperCase()

            let _n = _date + '-' + _user;

            
            let _region = undefined;
            if(user.user.system_region) {
                // _n = _n + '-' + decodeRegione(user.user.system_region).toUpperCase();
                setRegione(user.user.system_region);
            }
            
            let _province = undefined;
            if(user.user.system_province) {
                // _n = _n + '-' + user.user.system_province.toUpperCase();
                setProvincia(user.user.system_province);
            }
            
            setStockName(
                _n
            )
        }
    }, [user]);

    const handleConfirm = () => {
        
        //alert('newStock: '+ JSON.stringify(newStock));
        
        if(newStock) {
            const er = findFormErrors();

            //alert('er: '+ JSON.stringify(er));

            if (Object.values(er).filter(x => x !== defaultEMPTY).length > 0 ) {
                setErrors(er);
                return;
            }
        }
        
        //alert('stockToken: '+ JSON.stringify(stockToken));
        if(stockToken != defaultEMPTY) {
            setAppUniqueToken(stockToken);
        }

        //alert('stockName: '+ JSON.stringify(stockName));
        if(stockName != defaultEMPTY) {
            setSessionStock(stockName);
        }
        /*
        else {
            if(!newStock && selectedStock) {
                setSessionStock(selectedStock!.stock_name);
            }
        }
        */    

        if(stockPromoter != defaultEMPTY) {
            setSessionStockPromoter(stockPromoter);
        }

        //alert('regione: '+ JSON.stringify(regione));
        if(regione != defaultEMPTY)
            setSessionStockRegion(regione);

        //alert('provincia: '+ JSON.stringify(provincia));
        if(provincia != defaultEMPTY)
            setSessionStockProvince(provincia);


        if(newStock) 
            setNewSessionStock();
        else
            removeNewSessionStock();

        if(stockToken != defaultEMPTY || newStock) {
            props.onHide?.();
        }

        
        /*
        if (newStock && Object.values(er).filter(x => x !== defaultEMPTY).length > 0 ) {
            setErrors(er);
        }
        else { 
            if(stockToken != defaultEMPTY) {
                setAppUniqueToken(stockToken);
            }

            if(stockName != defaultEMPTY)
                setSessionStock(stockName);

            if(regione != defaultEMPTY)
                setSessionStockRegion(regione);

            if(provincia != defaultEMPTY)
                setSessionStockProvince(provincia);


            if(newStock) 
                setNewSessionStock();
            else
                removeNewSessionStock();

            if(stockToken != defaultEMPTY || newStock) {
                props.onHide?.();
            }
        }
        */

    };

    const handleOnChangeOpenStocks = (e: any) => {

        //alert('handleOnChangeOpenStocks: ' + JSON.stringify(e.target.value));
        setStockToken(e.target.value);
    };
    
    useEffect(() => {
        if(openStocks) {
            let s = openStocks.find((x: { stock_token: string; }) => x.stock_token == stockToken)
            if(s) {
                setStockName(s.stock_name);
                setSelectedStock(s);
            }
            else {
                setStockName(defaultEMPTY);
                setSelectedStock(undefined);
            }
        }
    }, [stockToken]);

    const renderOpenStocks = () => (
        openStocks && 
        <Form.Group controlId="gOPEN_STOCKS" className='m-3'>
            <FloatingLabel
                controlId="fOPEN_STOCKS"
                label={t('captions.openStocks')}
                className="mb-3"
            >
                <Form.Select
                    onChange={e => handleOnChangeOpenStocks(e)}
                >
                    <option key={defaultEMPTY} value={defaultEMPTY}></option>
                    {
                        /*
                        'stock_name'
                        , 'stock_token'
                        , 'stock_subscriptions_count'
                        , 'created_at'
                        */
                        openStocks.map(({ stock_token, stock_name, stock_subscriptions_count, created_at, stock_value }: any, idx: number) => (
                            <option key={'STK' + idx} value={stock_token} >
                                {
                                    moment(created_at).format(defaultMomentDateFormat)
                                    /*
                                    new Date(created_at).toLocaleDateString(
                                        "it-IT",
                                        {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric",
                                        }
                                    )
                                    */ 
                                    + ' - ' + stock_name
                                    + ' '
                                    + '- Tessere: ' + stock_subscriptions_count 
                                    + ' '
                                    + '- Valore: ' + stock_value
                                }
                            </option>
                        ))
                    }
                </Form.Select>
            </FloatingLabel>
        </Form.Group>
    );
    const renderNewStock = () => (
        newStock 
        &&
        <>
        <Form.Group controlId="gSTOCK_NAME" className='m-3'>
            <FloatingLabel
                controlId="fSTOCK_NAME"
                label={t('captions.stockName') + '*'}
                className="mb-3"
            >
                <Form.Control type="text"
                    placeholder={t('captions.stockName').toString() + '*'}
                    value={stockName}
                    onChange={e => handleStockName(e.target.value)}
                />
            </FloatingLabel>
        </Form.Group>
        <Form.Group controlId="gSTOCK_PROMOTER" className='m-3'>
            <FloatingLabel
                controlId="fSTOCK_PROMOTER"
                label={t('captions.stockPromoter') + '*'}
                className="mb-3"
            >
                <Form.Control type="text"
                    placeholder={t('captions.stockPromoter').toString() + '*'}
                    value={stockPromoter}
                    onChange={e => setField('stockPromoter', e.target.value)}
                    onFocus={() => setErrors({...errors, stockPromoter: defaultEMPTY})}
                    isInvalid={!!errors.stockPromoter}
                />
                <Form.Control.Feedback type="invalid">{errors.stockPromoter}</Form.Control.Feedback>
            </FloatingLabel>
        </Form.Group>
        <Form.Group controlId="gREGIONE" className='m-3'>
            <FloatingLabel
                controlId="floating_REGIONE"
                label={t('labels.region*')}
                className="mb-3"
            >
                <Form.Select
                    required
                    size="sm"
                    value={regione}
                    onChange={e => handleOnChangeRegion(e)}
                    onFocus={() => setErrors({...errors, regione: defaultEMPTY})}
                    isInvalid={!!errors.regione}
                    aria-label="floating_REGIONE select"
                >
                    <option key={defaultNONE} value={defaultNONE}></option>
                    {
                        jsonRegion.map(({id_regione, regione}, idx) => (
                            <option key={'REG' + idx} value={id_regione} >{regione}</option>
                        ))
                    }
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.regione}</Form.Control.Feedback>
            </FloatingLabel>
        </Form.Group>
        <Form.Group controlId="gPROVINCIA" className='m-3'>
            <FloatingLabel
                controlId="floating_PROVINCIA"
                label={t('labels.province')}
                className="mb-3"
            >
                <Form.Select
                    size="sm"
                    value={provincia}
                    onChange={e => handleOnChangeProvince(e)}
                    //onFocus={() => setErrors({...errors, provincia: defaultEMPTY})}
                    //isInvalid={!!errors.provincia}
                    aria-label="floating_PROVINCIA select"
                >
                    <option key={defaultNONE} value={defaultNONE}>Tutte le province</option>
                    {
                        jsonProvince.map(({sigla, provincia, id_regione}, idx) => (
                            <option key={'PRV' + idx} value={sigla} >{provincia}</option>
                        ))
                    }
                </Form.Select>
                <Form.Control.Feedback type="invalid">{errors.provincia}</Form.Control.Feedback>
            </FloatingLabel>
        </Form.Group>
        </>
    );


    const handleStockName = (e: any) => {
       setStockName(e);
    }


    const handleNewStock = (e: any) => {
        if(!isLoading)
            setNewStock(true)
    }
    const handleNewStockAndClose = (e: any) => {
        if(!isLoading) {

            //console.log('handleNewStockAndClose');

            axios.post('api/close-all', {})
            .then(res => {
                setNewStock(true);
            }).catch(err =>
            { 
                console.log(err);
            });
           
        }
    }
    const handleContinueStock = (e: any) => {
        if(!isLoading)
            setContinueStock(true)
    }
    const handleGoToLounge = (e: any) => {
        /*
        goToLounge = true;

        console.log('goToLounge: ' + JSON.stringify(goToLounge));
        props.onHide?.();
        */
        
        setIsLoading(true);
        setTimeout(() => {  goToLounge(e); }, 150)
    }
    const handleCancel = (e: any) => {

        if(newStock){
            formReset();
        }

        setNewStock(false);
        setContinueStock(false);
    }

    const renderCommands = () => (
        <>
            <Button className="btn_1 full-width text-white mb-1" variant="primary" onClick={(e) => handleNewStock(e)} disabled={isLoading}>
                {t('captions.newStock')}
            </Button>

            {
                openStocks 
                && openStocks.length > 0 
                && (
                    <>
                    {
                        /*
                        <Button className="btn_1 full-width text-white mb-1" variant="danger" onClick={(e) => handleNewStockAndClose(e)}>
                            {t('captions.newStockAndClose')}
                        </Button>   
                        */
                    }
                    <Button className="btn_1 full-width green text-white mb-1" onClick={(e) => handleContinueStock(e)} disabled={isLoading}>
                        {t('captions.continueStock')}
                    </Button>
                    </>
                )
            }

            <Button className="btn_1 full-width yellow text-bg-warning mt-3" 
                onClick={(e) => handleGoToLounge(e)}
                disabled={isLoading}
            >
                {
                    isLoading ? (
                    <Spinner
                        as="span"
                        //animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    ) : (
                    t("captions.lounge")
                    )
                }
            </Button>
            <Button key={'Logout'} id={'Logout'} className={'btn_1 mt-1'} variant='danger' 
                onClick={(e) => handleLogout(e)}
                disabled={isLogout}
            >
                {
                    isLogout ? (
                    <Spinner
                        as="span"
                        //animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                    ) : (
                    t("captions.logOut")
                    )
                }
            </Button>
        </>
    );

    const handleLogout = (e: any) => {

        setIsLogout(true);

        removeCurrentQuote();
        removeAppUniqueToken();

        setTimeout(() => {  setIsLogout(false); }, 250)
    };


    


    return (

        <Modal
            {...props}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body>
                <br />
                <Row>
                    <Col className={'text-center'}>
                        <Figure>
                            <Figure.Image
                                width={150}
                                src={'img/europaverde.png'} 
                                alt='europaverde_logo'
                            />
                            
                            <Figure.Caption>
                                <br />
                                
                                {   
                                    !!!newStock 
                                    && !!!continueStock 
                                    &&
                                    <>
                                    <h6>
                                        In questa finestra puoi scegliere se iniziare un nuovo inserimento tessere da inviare, 
                                        continuare e concludere un inserimento tessere già iniziato o entrare nella tua area utente
                                    </h6>
                                    <br />
                                    </>
                                }
                                
                                <h5>
                                {   
                                    newStock ? t('messages.newStockMessage')
                                    : continueStock ? t('messages.openStocksMessage')
                                    : t('messages.subscriptionFlow')
                                }
                                </h5>
                            </Figure.Caption>
                        </Figure>
                    </Col>
                </Row>
                <Row>
                    <Col className={'text-center'}>
                    {
                        newStock 
                        ? renderNewStock()
                        : continueStock && (
                            openStocks 
                            && openStocks.length > 0 
                            && renderOpenStocks()
                        )
                    }
                    </Col>
                </Row>
                <Row className={'gestione centered'}>
                {
                    /*
                    newStock ? <Button className="btn_1 yellow small" onClick={() => setNewStock(false)}>{t('captions.goBack')}</Button>
                    : <Button className="btn_1 green small" onClick={() => setNewStock(true)}>{t('messages.newStockMessage')}</Button>
                
                    <Button className="btn_1 green mt-2" onClick={() => handleConfirm()}>{t('captions.confirm')}</Button>
                    */
                }
                {
                    newStock || continueStock 
                    ? 
                        <>
                            <Button className="btn_1 green mt-2" onClick={() => handleConfirm()}>{t('captions.confirm')}</Button>
                            <Button className="btn_1 full-width yellow text-bg-warning mt-1" variant="outline" onClick={(e) => handleCancel(e)}>{t('captions.cancel')}</Button>
                        </>
                    : renderCommands()
                }
                </Row>

               
                <br />
            </Modal.Body>
        </Modal>
    );
};

export default SubscriptionFlow;
